module.exports = __webpack_public_path__ + "img/建筑.df10af61.jpg";